// Clean enquire list localStorage on every page load
const cwsCleanEnquireList = () => {
  const localStorageName = "enquire-list";
  
  if (localStorage.getItem(localStorageName) !== null) {
    try {
      const storedArr = JSON.parse(localStorage.getItem(localStorageName));
      if (Array.isArray(storedArr)) {
        const cleanedArr = storedArr.filter(item => item && typeof item === 'string' && item.trim() !== '');
        // Always save cleaned array back to ensure consistency
        localStorage.setItem(localStorageName, JSON.stringify(cleanedArr));
      }
    } catch (e) {
      console.error('Error cleaning enquire list:', e);
    }
  }
};

// Run immediately on page load (before DOM is ready)
cwsCleanEnquireList();

// Also run when DOM is ready as a backup
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', cwsCleanEnquireList);
} else {
  cwsCleanEnquireList();
}

const cwsSameHeight = () => {
  const box = document.querySelectorAll(".same-height");

  box.forEach((item) => {
    let minHeight = 0;

    const el = item.querySelectorAll(".same-height__el");
    const calc = () => {
      el.forEach((element) => {
        element.style.minHeight = `${minHeight}px`;

        if (element.clientHeight > minHeight) minHeight = element.clientHeight;
      });

      if (window.screen.width > 768) {
        el.forEach((element) => {
          element.style.minHeight = `${minHeight}px`;
        });
      } else {
        el.forEach((element) => {
          element.style.minHeight = "";
        });
      }
    };

    calc();

    window.addEventListener("resize", () => {
      minHeight = 0;

      calc();
    });
  });
};

cwsSliders = () => {
  const swiperBrandsXl = new Swiper(".swiper--brands-xl", {
    // Optional parameters
    slidesPerView: 1,
    slidesPerGroup: 1,
    loop: true,

    // Navigation arrows
    navigation: {
      nextEl: ".brand-xl-next",
      prevEl: ".brand-xl-prev",
    },

    breakpoints: {
      767: {
        slidesPerView: 5,
        loop: false,
      },
    },
  });
  const swiperBrands = new Swiper(".swiper--brands", {
    // Optional parameters
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 20,
    loop: true,

    // If we need pagination
    pagination: {
      el: ".swiper-pagination",
    },

    // Navigation arrows
    navigation: {
      nextEl: ".brand-next",
      prevEl: ".brand-prev",
    },

    breakpoints: {
      // when window width is >= 320px
      768: {
        slidesPerView: 4,
      },
      // when window width is >= 480px
      992: {
        slidesPerView: 5,
        slidesPerGroup: 3,
      },
      // when window width is >= 640px
      1280: {
        slidesPerView: 6,
        slidesPerGroup: 3,
      },
    },
  });

  const swiperReviews = new Swiper(".swiper--reviews", {
    // Optional parameters
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 30,
    loop: true,

    // If we need pagination
    pagination: {
      el: ".reviews__paginator",
    },

    // Navigation arrows
    navigation: {
      nextEl: ".review-next",
      prevEl: ".review-prev",
    },

    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });

  const swiperProducts = new Swiper(".swiper--products", {
    // Optional parameters
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 30,
    autoHeight: true,
    // loop: true,

    // If we need pagination
    pagination: {
      el: ".swiper-pagination",
    },

    // Navigation arrows
    navigation: {
      nextEl: ".products-next",
      prevEl: ".products-prev",
    },

    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
      1280: {
        slidesPerView: 5,
        spaceBetween: 30,
      },
    },
  });

  const swiperAccessories = new Swiper(".swiper--accessories", {
    // Optional parameters
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 30,
    observer: true,
    observeParents: true,
    // loop: true,

    // Navigation arrows
    navigation: {
      nextEl: ".accessories-next",
      prevEl: ".accessories-prev",
    },

    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1280: {
        slidesPerView: 3,
      },
    },
  });

  const swiperRelated = new Swiper(".swiper--related-products", {
    // Optional parameters
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 30,
    // loop: true,

    // Navigation arrows
    navigation: {
      nextEl: ".related-products__box .products-next",
      prevEl: ".related-products__box .products-prev",
    },

    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      1280: {
        slidesPerView: 4,
      },
      1440: {
        slidesPerView: 5,
      },
    },
  });

  const swiperOther = new Swiper(".swiper--other-products", {
    // Optional parameters
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 30,
    // loop: true,

    // Navigation arrows
    navigation: {
      nextEl: ".other-products__box .products-next",
      prevEl: ".other-products__box .products-prev",
    },

    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      1280: {
        slidesPerView: 4,
      },
      1440: {
        slidesPerView: 5,
      },
    },
  });
};

const cwsAcceptCheckbox = () => {
  const box = document.querySelector(".accept-cb");
  const cb = box?.querySelector("#accept-cb");
  const ap = box?.querySelector("#accept-ap");
  const input = box?.querySelector(".button");
  const checkCb = () => {
    const bothChecked = cb?.checked === true && ap?.checked === true;
    if (input) {
      if (bothChecked) {
        input.removeAttribute("disabled");
      } else {
        input.setAttribute("disabled", true);
      }
    }
  };

  cb?.addEventListener("change", checkCb);
  ap?.addEventListener("change", checkCb);
  checkCb();
};

const cwsAddProduct = () => {
  const btn = document.getElementById("add-product");
  let i = 2;

  if (btn !== null) {
    btn.addEventListener("click", (e) => {
      e.preventDefault();

      const product = document.createElement("div");
      const parent = document.getElementById("product-add-row");

      product.classList.add("form-products__row");

      product.innerHTML = `<div class="form-group form-group--no-mb"><input type="text" name="contact[product-code-${i}]"></div><div class="form-group form-group--no-mb"><input type="text" name="contact[product-qty-${i}]">
        </div><a href="#" class="remove-adedded-product"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 40 40"><path d="M23.868 20.015L39.117 4.78c1.11-1.108 1.11-2.77 0-3.877-1.109-1.108-2.773-1.108-3.882 0L19.986 16.137 4.737.904C3.628-.204 1.965-.204.856.904c-1.11 1.108-1.11 2.77 0 3.877l15.249 15.234L.855 35.248c-1.108 1.108-1.108 2.77 0 3.877.555.554 1.248.831 1.942.831s1.386-.277 1.94-.83l15.25-15.234 15.248 15.233c.555.554 1.248.831 1.941.831s1.387-.277 1.941-.83c1.11-1.109 1.11-2.77 0-3.878L23.868 20.015z" fill="#C7632E"></svg></a></div>`;

      parent.append(product);

      i++;
    });

    document.addEventListener("click", (e) => {
      if (!e.target.closest(".remove-adedded-product")) {
        return;
      } else {
        e.preventDefault();

        var btn = e.target.closest(".remove-adedded-product");
        var parent = btn.closest(".form-products__row");

        parent.remove();
      }
    });
  }
};

const cwsAdress = () => {
  const addressEl = document.querySelector("#delivery-address");

  if (addressEl !== null) {
    // Load customer address from Propella
    fetch("/a/cws/addresses", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ customer_code: window.LOGGED_IN_CUSTOMER_CODE }),
    })
      .then((res) => res.json())
      .then((res) => {
        // Remove "Loading..." option
        addressEl.removeChild(addressEl.querySelector("option:last-child"));

        for (const addr of res.data) {
          const opt = document.createElement("option");

          opt.dataset.AddressName = addr.AddressName;
          let addrStr = addr.AddressName;

          for (let i = 1; i <= 5; i++) {
            opt.dataset[`Address${i}`] = addr[`Address${i}`].trim();
            if (addr[`Address${i}`].trim().length) {
              addrStr += ", " + addr[`Address${i}`];
            }
          }

          const postcode = addr["Postcode"].trim() ?? "";
          opt.dataset.Postcode = postcode;
          if (postcode.length) {
            addrStr += ", " + postcode;
          }

          const phone = addr["Phone"].trim() ?? "";
          opt.dataset.Phone = phone;
          if (phone.length) {
            addrStr += ", " + phone;
          }

          // const email = addr["Email"].trim();
          // opt.dataset.Email = email;
          // if (email.length) {
          //   addrStr += ", " + email;
          // }

          opt.textContent = addrStr;
          opt.value = addrStr;
          addressEl.insertAdjacentElement("beforeend", opt);
        }
      });
  }
};

const cwsFormsPopup = () => {
  const body = document.body;
  const closePopup = document.querySelector(".popup__item-close");

  closePopup?.addEventListener("click", (e) => {
    e.preventDefault();

    body.classList.remove("pp-visible");
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      body.classList.remove("pp-visible");
    }
  });
};

const cwsTabs = () => {
  const tabs = document.querySelectorAll(".tabs");

  tabs.forEach((tab) => {
    const list = tab.querySelectorAll(".tabs__list li");
    const boxes = tab.querySelectorAll(".tabs__box");
    const accordions = tab.querySelectorAll(".tab__accordion");
    const activeClass = "active";

    list[0].classList.add(activeClass);
    boxes[0].classList.add(activeClass);

    accordions.forEach((accordion) => {
      accordion.addEventListener("click", (e) => {
        e.preventDefault();

        accordion.classList.toggle(activeClass);
        accordion.nextElementSibling.classList.toggle(activeClass);
      });
    });

    list.forEach((item, index) => {
      item.addEventListener("click", () => {
        const parent = item.closest(".tabs");

        const activeTabList = parent.querySelector(
          `.tabs__list .${activeClass}`
        );
        if (activeTabList) {
          activeTabList.classList.remove(activeClass);
        }

        const activeTabBox = parent.querySelector(`.tabs__box.${activeClass}`);
        if (activeTabBox) {
          activeTabBox.classList.remove(activeClass);
        }

        item.classList.add(activeClass);
        if (boxes[index]) {
          boxes[index].classList.add(activeClass);
        }
      });
    });
  });
};

const cwsAddValueEnquire = () => {
  const url = window.location;

  if (url.href.indexOf("enquire") !== -1 && url.href.indexOf("enquire-list") === -1) {
    const queryString = url.search;
    const urlParams = new URLSearchParams(queryString);
    const product = urlParams.get("product");
    const input = document.getElementById("ContactForm-product");
    if (input) {
      input.value = product;
    }
  }
};

const cwsAddToCart = () => {
  document.addEventListener("DOMContentLoaded", () => {
    document.addEventListener("click", (e) => {
      if (e.target.closest("a[data-add-to-cart]")) {
        e.preventDefault();

        const btn = e.target.closest("[data-add-to-cart]");

        if (btn.classList.contains("ajax-add-to-card--disabled")) {
          return;
        }

        const thisBtn = btn;
        const parent = thisBtn.closest(".card-list__controls");
        const input = parent.querySelector(".quantity__input");
        const qty = input ? input.value : 1; // Default to 1 if no quantity input found
        const productId = thisBtn.getAttribute("data-id");
        const errorMsg = parent.querySelector(".add-to-cart-ajax__error");
        const loader = parent.querySelector("[data-loader]");
        const txt = parent.querySelector("[data-txt]");
        const txtTitle = txt ? txt.textContent : "add to cart";
        const request = {
          method: "POST",
          headers: {
            "Content-Type": "application/json;",
          },
          body: JSON.stringify({
            quantity: qty,
            id: productId,
          }),
        };

        if (txt) txt.classList.add("hide");
        if (loader) loader.classList.remove("hide");

        fetch("/cart/add.js", request)
          .then((response) => {
            return response.json();
          })
          .then((product) => {
            fetch("/cart.js")
              .then((response) => {
                return response.json();
              })
              .then((cart) => {
                let cartCount = document.querySelector("[data-cart-count]");
                
                // If cart count element doesn't exist (first product added), create it
                if (!cartCount) {
                  const cartIcon = document.getElementById("cart-icon-bubble");
                  if (cartIcon) {
                    // Check if cart-count-bubble exists, if not create it
                    let cartBubble = cartIcon.querySelector(".cart-count-bubble");
                    if (!cartBubble) {
                      cartBubble = document.createElement("div");
                      cartBubble.classList.add("cart-count-bubble");
                      cartIcon.appendChild(cartBubble);
                    }
                    // Create the data-cart-count span
                    cartCount = document.createElement("span");
                    cartCount.setAttribute("aria-hidden", "true");
                    cartCount.setAttribute("data-cart-count", "");
                    cartBubble.appendChild(cartCount);
                  }
                }

                if (cartCount) {
                  cartCount.textContent = cart.item_count;
                }

                if (loader) loader.classList.add("hide");
                if (txt) {
                  txt.classList.remove("hide");
                  txt.textContent = "Added";

                  // setTimeout(() => {
                  //   txt.textContent = txtTitle;
                  // }, 800);
                }
              });
          })
          .catch(function (response) {
            errorMsg.textContent = response;
          });
      }
    });
  });
};

const cwsMobileSlider = () => {
  const sliders = document.querySelectorAll(".custom-mobile-slider");

  sliders.forEach((slider) => {
    const slides = slider.querySelector(".custom-mobile-slides");
    const paginator = slider.querySelector(".custom-mobile-paginator");
    const list = paginator.querySelectorAll("span");
    const activeClass = "active";

    list.forEach((li, index) => {
      li.addEventListener("click", () => {
        li.parentNode
          .querySelector(`.${activeClass}`)
          .classList.remove(activeClass);
        li.classList.add(activeClass);

        slides.scrollTo({
          left: slides.clientWidth * index,
        });
      });
    });

    slides.addEventListener("scroll", () => {
      const index = Math.round(slides.scrollLeft / slides.clientWidth);

      list.forEach((li) => li.classList.remove(activeClass));

      list[index].classList.add(activeClass);
    });
  });
};

const cwsOpenMobileSorting = () => {
  const openMenu = document.querySelector(".mobile-filter");
  const closeMenu = document.querySelector(".close-filter");
  const body = document.body;

  openMenu?.addEventListener("click", () => {
    body.classList.add("ms-visible");
  });

  closeMenu?.addEventListener("click", (e) => {
    e.preventDefault();

    body.classList.remove("ms-visible");
  });
};

const cwsAlignLink = () => {
  const links = document.querySelectorAll(".about__info a");

  links.forEach((link) => {
    if (link.getAttribute("href").indexOf("team") > -1) {
      link.classList.add("about__info-link");
    }
  });
};

const cwsEnquireList = () => {
  const headerIcon = document.querySelector(".enquire-icon");
  const count = document.querySelector(".enquire-icon span");
  const defaultTitle = "Enquire";
  const addedTitle = "Added";
  const addingTitle = "Adding";
  const removingingTitle = "Removing";
  const localStorageName = "enquire-list";
  const activeClass = "add-to-enquire--disabled";
  const time = 600;
  const enquireInput = document.getElementById("enquire-input");
  const enquireList = document.getElementById("enquire-list");

  let enquireArr = [];
  let enquireArrTitle = [];

  // Helper function to filter out empty strings
  const filterEmptyStrings = (arr) => {
    return arr.filter(item => item && item.trim() !== '');
  };

  // Helper to set enquire button to "added" state (icon + text)
  const addedStateSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="21" viewBox="0 0 24 21" class="icon"><path d="M24.0010821,19.0259646 L7.50108211,19.0259646 L7.50108211,17.1509646 L24.0010821,17.1509646 L24.0010821,19.0259646 Z M5.62608211,18.0889646 C5.62608211,16.9511214 4.94060835,15.9253363 3.88933951,15.489996 C2.83807068,15.0546557 1.62807081,15.2955074 0.823637154,16.1002271 C0.019203503,16.9049468 -0.22121794,18.1150322 0.214496111,19.1661462 C0.650210163,20.2172602 1.67623891,20.9023691 2.81408211,20.9019648 C4.36681144,20.9003103 5.62497981,19.6416945 5.62608211,18.0889646 Z M3.75108265,18.0889646 C3.75148667,18.468441 3.52320699,18.8107766 3.17273263,18.9562763 C2.82225826,19.101776 2.41864383,19.0217717 2.15017032,18.7535844 C1.88169682,18.4853972 1.80126206,18.0818683 1.94638785,17.7312389 C2.09151364,17.3806096 2.43360557,17.1519646 2.81308211,17.1519646 C3.33050705,17.1525145 3.74998033,17.5715406 3.75108265,18.0889646 Z M24.0010821,9.32296463 L7.50108211,9.32296463 L7.50108211,11.1979646 L24.0010821,11.1979646 L24.0010821,9.32296463 Z M5.62608211,10.2599646 C5.62608211,9.12212135 4.94060835,8.09633627 3.88933951,7.66099598 C2.83807068,7.22565568 1.62807081,7.46650736 0.823637154,8.27122708 C0.019203503,9.07594681 -0.22121794,10.2860322 0.214496111,11.3371462 C0.650210163,12.3882602 1.67623891,13.0733691 2.81408211,13.0729648 C4.36681144,13.0713103 5.62497981,11.8126945 5.62608211,10.2599646 Z M3.75108265,10.2599646 C3.75148667,10.639441 3.52320699,10.9817766 3.17273263,11.1272763 C2.82225826,11.272776 2.41864383,11.1927717 2.15017032,10.9245844 C1.88169682,10.6563972 1.80126206,10.2528683 1.94638785,9.90223893 C2.09151364,9.55160956 2.43360557,9.32296463 2.81308211,9.32296463 C3.33050705,9.3235145 3.74998033,9.74254058 3.75108265,10.2599646 L3.75108265,10.2599646 Z M24.0010821,1.82296463 L7.50108211,1.82296463 L7.50108211,3.69796463 L24.0010821,3.69796463 L24.0010821,1.82296463 Z M5.62608211,2.75996463 C5.59718125,1.22733272 4.3464865,8.8817842e-16 2.81358211,8.8817842e-16 C1.28067773,8.8817842e-16 0.0299829834,1.22733272 0.0010821144,2.75996463 C0.0299829834,4.29259655 1.28067773,5.51992927 2.81358211,5.51992927 C4.3464865,5.51992927 5.59718125,4.29259655 5.62608211,2.75996463 Z M3.75108265,2.75996463 C3.75148667,3.13944096 3.52320699,3.48177658 3.17273263,3.6272763 C2.82225826,3.77277601 2.41864383,3.69277173 2.15017032,3.42458444 C1.88169682,3.15639716 1.80126206,2.75286829 1.94638785,2.40223893 C2.09151364,2.05160956 2.43360557,1.82296463 2.81308211,1.82296463 C3.33050705,1.8235145 3.74998033,2.24254058 3.75108265,2.75996463 Z"></path></svg>';
  const setAddedState = (btn) => {
    btn.innerHTML = addedStateSvg + ' ' + addedTitle;
  };

  // Clean array on load
  if (localStorage.getItem(localStorageName) !== null) {
    const storedArr = JSON.parse(localStorage.getItem(localStorageName));
    enquireArr = filterEmptyStrings(storedArr);
    // Save cleaned array back if empty strings were removed
    if (storedArr.length !== enquireArr.length) {
      localStorage.setItem(localStorageName, JSON.stringify(enquireArr));
    }
  }

  if (headerIcon !== null) {
    if (enquireArr.length > 0) {
      headerIcon.style.display = "flex";
    }
    count.textContent = enquireArr.length;
  }

  const enquireBtns = document.querySelectorAll("[data-enquire-handle]");

  enquireBtns.forEach((enquireBtn) => {
    const handle = enquireBtn.getAttribute("data-enquire-handle");

    if (enquireArr.indexOf(handle) > -1) {
      enquireBtn.classList.add(activeClass);
      setAddedState(enquireBtn);
    }

    enquireBtn.addEventListener("click", (e) => {
      e.preventDefault();

      if (enquireBtn.classList.contains(activeClass)) {
        const i = enquireArr.indexOf(handle);

        enquireBtn.textContent = removingingTitle;

        if (i > -1) {
          enquireArr.splice(i, 1);
          enquireArr = filterEmptyStrings(enquireArr);
          localStorage.setItem(localStorageName, JSON.stringify(enquireArr));
        }

        setTimeout(() => {
          enquireBtn.classList.remove(activeClass);
          enquireBtn.textContent = defaultTitle;
        }, time);
      } else {
        enquireBtn.textContent = addingTitle;
        enquireBtn.classList.add(activeClass);
        enquireArr.push(handle);
        enquireArr = filterEmptyStrings(enquireArr);
        localStorage.setItem(localStorageName, JSON.stringify(enquireArr));
        setTimeout(() => {
          setAddedState(enquireBtn);
        }, time);
      }

      if (headerIcon !== null) {
        if (enquireArr.length > 0) {
          headerIcon.style.display = "flex";
        } else {
          headerIcon.style.display = "none";
        }
      }

      count.textContent = enquireArr.length;
    });
  });

  if (enquireList !== null) {
    if (enquireArr.length === 0) {
      window.location = "/";
    }

    if (enquireArr.length > 0) {
      // Initialize enquireArrTitle with correct length to preserve order
      enquireArrTitle = new Array(enquireArr.length);
      
      enquireArr.forEach(function (product, index) {

        fetch("/products/" + product + ".js")
          .then((response) => response.json())
          .then((data) => {
            const product = document.createElement("div");
            let src = data.featured_image;

            product.classList.add("enquire-product");

            if (src !== null) {
              if (src.indexOf(".jpg") > -1) {
                let lastIndex = src.lastIndexOf(".jpg");
                src = src.substring(0, lastIndex) + "_x320.jpg";
              }

              if (src.indexOf(".png") > -1) {
                let lastIndex = src.lastIndexOf(".png");
                src = src.substring(0, lastIndex) + "_x320.png";
              }
            }

            product.innerHTML =
              '<div class="enquire-product__img"><a href="' +
              data.url +
              '"><img src="' +
              src +
              '" alt="' +
              data.title +
              '"></a></div><div class="enquire-product__title"><h3><a href="' +
              data.url +
              '">' +
              data.title +
              '</a></h3><a class="enquire-product__remove" href="#" data-handle="' +
              data.handle +
              '">Remove</a></div>';

            // Get SKU from first variant - check all variants for a SKU if first one is empty
            let sku = '';
            if (data.variants && data.variants.length > 0) {
              // Find first variant with a SKU
              for (let i = 0; i < data.variants.length; i++) {
                if (data.variants[i].sku && data.variants[i].sku.trim() !== '') {
                  sku = data.variants[i].sku;
                  break;
                }
              }
            }
            // Remove commas from title to avoid conflicts, then append SKU
            const titleWithoutCommas = data.title.replace(/,/g, '');
            const titleWithSku = sku ? `${titleWithoutCommas} (${sku})` : titleWithoutCommas;
            enquireArrTitle[index] = titleWithSku;
            enquireList.appendChild(product);

            if (enquireInput !== null) {
              // Filter out undefined values and join with commas
              enquireInput.value = enquireArrTitle.filter(item => item !== undefined).join(", ");
            }
          });
      });
    }
  }

  document.addEventListener("click", (e) => {
    if (e.target.closest(".enquire-product__remove")) {
      e.preventDefault();

      const btn = e.target.closest(".enquire-product__remove");
      const handle = btn.getAttribute("data-handle");
      const i = enquireArr.indexOf(handle);
      const parent = btn.closest(".enquire-product");

      if (i > -1) {
        enquireArr.splice(i, 1);
        enquireArrTitle.splice(i, 1);
        enquireArr = filterEmptyStrings(enquireArr);
        localStorage.setItem(localStorageName, JSON.stringify(enquireArr));
        parent.remove();
      }

      // Update header icon count and visibility
      if (headerIcon !== null) {
        if (enquireArr.length > 0) {
          headerIcon.style.display = "flex";
        } else {
          headerIcon.style.display = "none";
        }
      }

      if (count !== null) {
        count.textContent = enquireArr.length;
      }

      if (enquireInput !== null) {
        enquireInput.value = enquireArrTitle.filter(item => item !== undefined && item !== null).join(", ");
      }

      if (enquireArr.length === 0) {
        window.location = "/";
      }
    }
  });
};

  // Helper function to initialize enquire buttons for dynamically added elements
  function initializeEnquireButtons(container) {
    if (!container) return
    
    const enquireBtns = container.querySelectorAll("[data-enquire-handle]")
    if (enquireBtns.length === 0) return
    
    const headerIcon = document.querySelector(".enquire-icon")
    const count = document.querySelector(".enquire-icon span")
    const defaultTitle = "Enquire"
    const addedTitle = "Added"
    const addingTitle = "Adding"
    const removingingTitle = "Removing"
    const localStorageName = "enquire-list"
    const activeClass = "add-to-enquire--disabled"
    const time = 600
    
    // Get current enquire list from localStorage
    let enquireArr = []
    if (localStorage.getItem(localStorageName) !== null) {
      try {
        const storedArr = JSON.parse(localStorage.getItem(localStorageName))
        enquireArr = storedArr.filter(item => item && typeof item === 'string' && item.trim() !== '')
      } catch (e) {
        console.error('Error reading enquire list:', e)
      }
    }
    
    enquireBtns.forEach((enquireBtn) => {
      // Skip if already initialized (has event listener)
      if (enquireBtn.dataset.enquireInitialized === 'true') return
      
      const handle = enquireBtn.getAttribute("data-enquire-handle")
      
      // Set initial state
      if (enquireArr.indexOf(handle) > -1) {
        enquireBtn.classList.add(activeClass)
        enquireBtn.textContent = addedTitle
      }
      
      // Add click event listener
      enquireBtn.addEventListener("click", (e) => {
        e.preventDefault()
        
        // Re-read enquireArr from localStorage in case it changed
        let currentEnquireArr = []
        if (localStorage.getItem(localStorageName) !== null) {
          try {
            const storedArr = JSON.parse(localStorage.getItem(localStorageName))
            currentEnquireArr = storedArr.filter(item => item && typeof item === 'string' && item.trim() !== '')
          } catch (e) {
            console.error('Error reading enquire list:', e)
          }
        }
        
        if (enquireBtn.classList.contains(activeClass)) {
          const i = currentEnquireArr.indexOf(handle)
          
          enquireBtn.textContent = removingingTitle
          
          if (i > -1) {
            currentEnquireArr.splice(i, 1)
            currentEnquireArr = currentEnquireArr.filter(item => item && item.trim() !== '')
            localStorage.setItem(localStorageName, JSON.stringify(currentEnquireArr))
          }
          
          setTimeout(() => {
            enquireBtn.classList.remove(activeClass)
            enquireBtn.textContent = defaultTitle
          }, time)
        } else {
          enquireBtn.textContent = addingTitle
          enquireBtn.classList.add(activeClass)
          currentEnquireArr.push(handle)
          currentEnquireArr = currentEnquireArr.filter(item => item && item.trim() !== '')
          localStorage.setItem(localStorageName, JSON.stringify(currentEnquireArr))
          setTimeout(() => {
            enquireBtn.textContent = addedTitle
          }, time)
        }
        
        // Update header icon and count
        if (headerIcon !== null) {
          if (currentEnquireArr.length > 0) {
            headerIcon.style.display = "flex"
          } else {
            headerIcon.style.display = "none"
          }
        }
        
        if (count !== null) {
          count.textContent = currentEnquireArr.length
        }
      })
      
      // Mark as initialized
      enquireBtn.dataset.enquireInitialized = 'true'
    })
  }

  // Custom Predictive Search
  function initCustomPredictiveSearch() {
    const excludedCategoryHandles = new Set(window.CWS_PREDICTIVE_SEARCH_EXCLUDED_HANDLES || [])

    function filterExcludedCategories(collections) {
      if (!collections.length || excludedCategoryHandles.size === 0) return collections

      return collections.filter((collection) => {
        if (collection.handle && excludedCategoryHandles.has(collection.handle)) return false
        if (collection.url) {
          const handleFromUrl = collection.url.split('/collections/').pop()?.split(/[?#]/)[0]
          if (handleFromUrl && excludedCategoryHandles.has(handleFromUrl)) return false
        }
        return true
      })
    }

    const customSearchInputs = document.querySelectorAll('[custom-predictive-search]')
    
    customSearchInputs.forEach(input => {
      const form = input.closest('form')
      let predictiveSearchContainer = null
      let searchTimeout = null
      let isOpen = false

      // Create dropdown container for predictive search results
      function createPredictiveContainer() {
        if (predictiveSearchContainer) return predictiveSearchContainer
        
        predictiveSearchContainer = document.createElement('div')
        predictiveSearchContainer.className = 'custom-predictive-search'
        
        // Make parent form/container relative positioned
        const parent = input.closest('.header__search-box') || form
        if (parent) {
          const parentStyle = window.getComputedStyle(parent)
          if (parentStyle.position === 'static') {
            parent.style.position = 'relative'
          }
          parent.appendChild(predictiveSearchContainer)
        }
        
        return predictiveSearchContainer
      }

      // Check if input has 3+ characters
      function hasMinLength(value) {
        return value.trim().length >= 3
      }

      function escapeHtml(text) {
        const div = document.createElement('div')
        div.textContent = text || ''
        return div.innerHTML
      }

      // Fetch predictive search results
      function fetchPredictiveResults(query) {
        if (!query || !hasMinLength(query)) {
          hidePredictiveSearch()
          return
        }

        const searchParams = new URLSearchParams()
        searchParams.set('q', query)
        
        if ("LOGGED_IN_CUSTOMER_ID" in window) {
          searchParams.set('scid', window.LOGGED_IN_CUSTOMER_ID)
        }
        if ("LOGGED_IN_CUSTOMER_CODE" in window) {
          searchParams.set('pcode', window.LOGGED_IN_CUSTOMER_CODE)
        }

        const collectionParams = new URLSearchParams()
        collectionParams.set('q', query)
        collectionParams.set('resources[type]', 'collection')
        collectionParams.set('resources[limit]', '20')

        const container = createPredictiveContainer()
        container.innerHTML = '<div class="custom-predictive-search__loading">Loading...</div>'
        showPredictiveSearch()

        Promise.all([
          fetch('/search/suggest.json?' + collectionParams.toString()).then(res => res.json()).catch(() => null),
          fetch('/a/cws/search?' + searchParams.toString()).then(res => res.json()).catch(() => null)
        ])
          .then(([suggestRes, productsRes]) => {
            const categories = filterExcludedCategories(suggestRes?.resources?.results?.collections || []).slice(0, 6)
            const products = productsRes?.success && productsRes?.data ? productsRes.data : []

            if (categories.length > 0 || products.length > 0) {
              renderPredictiveResults(categories, products)
            } else {
              container.innerHTML = '<div class="custom-predictive-search__no-results">No results found</div>'
            }
          })
          .catch(e => {
            container.innerHTML = `<div class="custom-predictive-search__error">Error: ${e.message}</div>`
          })
      }

      // Format money helper (matching cws.js format)
      function formatMoney(x) {
        return '$' + (x/100).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }

      // Fetch special prices for predictive search results
      function fetchPredictiveSpecialPrices(container) {
        if (!container) return;
        const elements = container.querySelectorAll('[data-cws-csp]');
        if (elements.length === 0) return;

        const skus = [];
        const cwsCspReqPayload = [];
        
        for (const el of elements) {
          if (el.dataset.cwsCsp && el.dataset.cwsCsp.length && !el.textContent.length) {
            if (skus.indexOf(el.dataset.cwsCsp) === -1) {
              skus.push(el.dataset.cwsCsp);
              cwsCspReqPayload.push({
                sku: el.dataset.cwsCsp,
                qty: el.dataset.qty ?? 1,
              });
            }
          } else if (el.dataset.sPrice) {
            // Fallback to regular price if no special price
            el.textContent = formatMoney((el.dataset.qty ?? 1) * el.dataset.sPrice);
          }
        }

      if (cwsCspReqPayload.length > 0 && window.LOGGED_IN_CUSTOMER_CODE) {
          fetch('/a/cws/csp', {
            method: 'POST',
            body: JSON.stringify({
              customer: window.LOGGED_IN_CUSTOMER_CODE,
              items: cwsCspReqPayload
            })
          }).then(res => res.json())
            .then(res => {
              if (res.success && res.data) {
                for (const reqItem of cwsCspReqPayload) {
                  container.querySelectorAll(`[data-cws-csp='${reqItem.sku}']`).forEach(el => {
                    const specialPrice = res.data[reqItem.sku];
                    if (specialPrice) {
                      el.textContent = formatMoney((el.dataset.qty ?? 1) * specialPrice * 100);
                    } else {
                      el.textContent = formatMoney((el.dataset.qty ?? 1) * el.dataset.sPrice);
                    }
                  });
                }
              } else {
                // Fallback to regular price
                for (const reqItem of cwsCspReqPayload) {
                  container.querySelectorAll(`[data-cws-csp='${reqItem.sku}']`).forEach(el => {
                    el.textContent = formatMoney((el.dataset.qty ?? 1) * el.dataset.sPrice);
                  });
                }
              }
            })
            .catch(e => {
              console.log('Error fetching special prices:', e);
              // Fallback to regular price
              for (const reqItem of cwsCspReqPayload) {
                container.querySelectorAll(`[data-cws-csp='${reqItem.sku}']`).forEach(el => {
                  el.textContent = formatMoney((el.dataset.qty ?? 1) * el.dataset.sPrice);
                });
              }
            });
        } else if (elements.length > 0) {
          // No special pricing available, use regular price
          elements.forEach(el => {
            if (el.dataset.sPrice) {
              el.textContent = formatMoney((el.dataset.qty ?? 1) * el.dataset.sPrice);
            }
          });
        }
      }

      // Helper function to determine visibility flags (matches product-card-list.liquid logic)
      function getProductVisibilityFlags(product) {
        let showAddToCart = false
        let showPrice = false
        let showAvailability = false
        let isPoa = false
        
        // Check if product has POA tag
        if (product.poa || (product.tags && Array.isArray(product.tags) && product.tags.includes('POA'))) {
          isPoa = true
        }
        
        // Check customer tags if customer exists
        if (typeof window.LOGGED_IN_CUSTOMER_ID !== 'undefined' && window.LOGGED_IN_CUSTOMER_ID) {
          const customerTags = window.LOGGED_IN_CUSTOMER_TAGS || []
          const hasPropellaCompetitor = customerTags.includes('PropellaCompetitor')
          const hasPropellaViewOnly = customerTags.includes('PropellaViewOnly')
          
          if (hasPropellaCompetitor) {
            showAvailability = true
          } else if (hasPropellaViewOnly) {
            showAvailability = true
            if (!isPoa) {
              showPrice = true
            }
          } else {
            if (!isPoa) {
              showPrice = true
              showAddToCart = true
            }
            showAvailability = true
          }
        }
        
        return {
          showAddToCart,
          showPrice,
          showAvailability,
          isPoa
        }
      }

      // Render predictive search results
      function renderPredictiveResults(categories, products) {
        const container = createPredictiveContainer()
        let html = '<div class="custom-predictive-search__sections">'

        if (categories.length > 0) {
          html += `
            <div class="custom-predictive-search__section">
              <div class="custom-predictive-search__heading">Product Category</div>
              <ul class="custom-predictive-search__category-list">
          `

          categories.forEach(category => {
            html += `
              <li class="custom-predictive-search__category-item">
                <a href="${category.url}" class="custom-predictive-search__category-link">${escapeHtml(category.title)}</a>
              </li>
            `
          })

          html += '</ul></div>'
        }

        const limitedResults = products.slice(0, 5)

        if (limitedResults.length > 0) {
          html += `
            <div class="custom-predictive-search__section">
              <div class="custom-predictive-search__heading">Product</div>
              <ul class="custom-predictive-search__list">
          `
        
        limitedResults.forEach((product, index) => {
          const imageUrl = product.image?.replace('.jpg', '_150x150.jpg').replace('.png', '_150x150.png') || 'https://cdn.shopify.com/s/images/admin/no-image-large.gif'
          const productUrl = `/products/${product.handle}`
          // Convert price to cents for data-s-price (assuming price is in dollars)
          const priceInCents = Math.round((parseFloat(product.price) || 0) * 100)
          const sku = product.sku || ''
          const variantId = product.id || ''
          const visibilityFlags = getProductVisibilityFlags(product)
          const showAddToCart = visibilityFlags.showAddToCart
          const showPrice = visibilityFlags.showPrice
          
          html += `
            <li class="custom-predictive-search__item">
              <a href="${productUrl}" class="custom-predictive-search__link">
                <img src="${imageUrl}" alt="${product.title}" class="custom-predictive-search__image">
                <div class="custom-predictive-search__content">
                  <div class="custom-predictive-search__sku">${sku || ''}</div>
                  <div class="custom-predictive-search__title">${product.title}</div>
                  ${showPrice ? `
                  <div class="custom-predictive-search__price">
                    ${sku ? `<span class="price-item price-item--regular" data-cws-csp="${sku}" data-s-price="${priceInCents}"></span>` : `$${(parseFloat(product.price) || 0).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}`}
                  </div>
                  ` : ''}
                </div>
              </a>
              ${variantId ? (showAddToCart ? (sku ? `
                <div class="card-list__controls custom-predictive-search__controls">
                  <a href="#" class="button button--primary custom-predictive-search__button" data-id="${variantId}" data-add-to-cart>
                    <span class="hide" data-loader="">adding</span>
                    <span data-txt="">add to cart</span>
                  </a>
                  <div class="add-to-cart-ajax__error custom-predictive-search__error-message"></div>
                </div>
              ` : `
                <div class="card-list__controls custom-predictive-search__controls">
                  <a href="${productUrl}" class="button button--primary">More info</a>
                </div>
              `) : `
                <div class="card-list__controls custom-predictive-search__controls">
                  <a href="/pages/enquire?product=${encodeURIComponent(product.title)}" class="button button--primary add-to-enquire custom-predictive-search__button" data-enquire-handle="${product.handle}">Enquire now</a>
                </div>
              `) : ''}
            </li>
          `
        })
        
          html += '</ul></div>'
        }

        html += '</div>'
        container.innerHTML = html
        showPredictiveSearch()
        
        // Initialize enquire buttons for dynamically added elements
        initializeEnquireButtons(container)
        
        // Fetch special prices after rendering
        fetchPredictiveSpecialPrices(container)
      }

      // Show predictive search dropdown
      function showPredictiveSearch() {
        const container = createPredictiveContainer()
        container.classList.add('is-open')
        isOpen = true
      }

      // Hide predictive search dropdown
      function hidePredictiveSearch() {
        if (predictiveSearchContainer) {
          predictiveSearchContainer.classList.remove('is-open')
          isOpen = false
        }
      }

      // Input event listener
      input.addEventListener('input', (e) => {
        const query = e.target.value.trim()
        
        clearTimeout(searchTimeout)
        
        if (query.length === 0) {
          hidePredictiveSearch()
          return
        }

        // Debounce the search
        searchTimeout = setTimeout(() => {
          if (hasMinLength(query)) {
            fetchPredictiveResults(query)
          } else {
            hidePredictiveSearch()
          }
        }, 300)
      })

      // Focus event listener
      input.addEventListener('focus', (e) => {
        const query = e.target.value.trim()
        if (query && hasMinLength(query) && predictiveSearchContainer) {
          showPredictiveSearch()
        }
      })

      // Click outside to close
      document.addEventListener('click', (e) => {
        if (isOpen && predictiveSearchContainer && !predictiveSearchContainer.contains(e.target) && e.target !== input) {
          hidePredictiveSearch()
        }
      })

      // Close on form submit
      if (form) {
        form.addEventListener('submit', () => {
          hidePredictiveSearch()
        })
      }
    })
  }

  // Initialize custom predictive search when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomPredictiveSearch)
  } else {
    initCustomPredictiveSearch()
  }

cwsAlignLink();
cwsAdress();
cwsSameHeight();
cwsSliders();
cwsAcceptCheckbox();
cwsAddProduct();
cwsFormsPopup();
cwsTabs();
cwsAddValueEnquire();
cwsAddToCart();
cwsMobileSlider();
cwsOpenMobileSorting();
cwsEnquireList();
